import { Component, signal } from '@angular/core'
import { DashboardComponent, DashboardData } from './dashboard.component'
import { DashboardContentComponent } from './dashboard-content.component'

@Component({
  selector: 'app-default-dashboard',
  imports: [
    DashboardComponent,
    DashboardContentComponent,
  ],
  template: `
    <app-dashboard (onData)="data.set($event)">
      @if (data()) {
        <app-dashboard-content [title]="data()!.config.display" [url]="data()!.url" />
      }
    </app-dashboard>
  `,
})
export class DefaultDashboardComponent {
  protected readonly data = signal<DashboardData | undefined>(undefined)
}
